import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column mb-7 fv-row fv-plugins-icon-container" }
const _hoisted_2 = { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fad text-muted fa-info-circle ms-2" }, null, -1)
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_Skeletor = _resolveComponent("Skeletor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _createElementVNode("span", {
        class: _normalizeClass({'required': _ctx.isRequired})
      }, _toDisplayString(_ctx.label), 3),
      (_ctx.tooltip)
        ? (_openBlock(), _createBlock(_component_el_tooltip, {
            key: 0,
            content: _ctx.tooltip,
            placement: "bottom"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["content"]))
        : _createCommentVNode("", true),
      (_ctx.actionLabel)
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitActionClick && _ctx.emitActionClick(...args))),
            class: "ms-auto text-muted text-hover-primary cursor-pointer fw-normal"
          }, _toDisplayString(_ctx.actionLabel), 1))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.isLoading)
      ? _renderSlot(_ctx.$slots, "default", { key: 0 })
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_Skeletor, { height: "43" })
        ])),
    _hoisted_5
  ]))
}